function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}

// localStorage only holds strings, so a value that was never a real token comes back
// as "undefined" or "null" rather than as an absent key. Treat those as absent.
function isUsableToken(value) {
    return typeof value === "string" && value !== "" && value !== "undefined" && value !== "null";
}

/**
 * Whether the user still has a session.
 *
 * An expired access token does not end the session. The access token lasts an hour,
 * the refresh token thirty days, and the axios interceptor exchanges one for the
 * other on the first 401. Discarding the refresh token here -- which is what this
 * used to do -- forced a full password-and-OTP login every time the hour lapsed, or
 * whenever any endpoint happened to return a 401.
 *
 * So the session is over only when there is no refresh token left to try.
 */
export function isAuthenticated() {
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    if (isUsableToken(accessToken)) {
        try {
            const jwtPayload = parseJwt(accessToken);
            if (jwtPayload.exp > Date.now() / 1000) {
                return true;
            }
        } catch (error) {
            // Unreadable rather than expired -- fall through and let the refresh decide.
            console.error("Could not read the access token:", error);
        }
    }

    if (isUsableToken(refreshToken)) {
        // Keep the refresh token. The next API call 401s and the interceptor renews it.
        return true;
    }

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    return false;
}